<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posTransactionDetails.transaction_reference') }}</label></td>
      <td>{{ details.transaction_reference }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posTransactionDetails.committed_at') }}</label></td>
      <td><span v-if="details.committed_at">{{ details.committed_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('posTransactionDetails.request_id') }}</label></td>
      <td>{{ details.request_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posTransactionDetails.processing_status') }}</label></td>
      <td>{{ details.processing_status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posTransactionDetails.processed_at') }}</label></td>
      <td><span v-if="details.processed_at">{{ details.processed_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.metadata') }}</label></td>
      <td><meta-data-details :data="details.metadata"/></td>
    </tr>
    <tr>
      <td><label>{{ $t('posTransactionDetails.distributor_client_id') }}</label></td>
      <td>{{ details.distributor_client_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('posTransactionDetails.distributor_id') }}</label></td>
      <td><router-link :to="{name: 'distributor', params: {id: details.distributor_id}}">
        {{ details.distributor_id }}
      </router-link>
        </td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
<!--    <tr>-->
<!--      <td><label>{{ $t('posTransactionDetails.operations') }}</label></td>-->
<!--      <td>{{ details.operations }}</td>-->
<!--    </tr>-->
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
  </table>
</template>
<script>
  import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";

  export default {
    name: 'posTransactionDetails',
    components: {
      MetaDataDetails
    },
    props: {
      details: {
        type: Object,
        required: true,
      },
    },
    computed: {
    }
  };
</script>
<style></style>
